import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AlertPortal } from 'AppSrc/core/components/portals/alert-portal';
import { AlertOptions } from './sub-components/alert-options';
import 'AppSrc/core/style/components/utility/alert.css';


const alertDataShape = PropTypes.shape({
  alertTitle: PropTypes.string,
  alertText: PropTypes.string,
  option: PropTypes.any,
  Icon: PropTypes.elementType,
  showFalse: PropTypes.bool,
  showTrue: PropTypes.bool,
  falseText: PropTypes.string,
  trueText: PropTypes.string,
  falseButtonCols: PropTypes.number,
  trueButtonCols: PropTypes.number,
  className: PropTypes.string,
});

class Alert extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      resolveAlert,
      alertData,
    } = this.props;

    const {
      alertTitle,
      alertText,
      option,
      falseText,
      trueText,
      falseButtonCols,
      trueButtonCols,
      Icon,
      showFalse,
      showTrue,
      className,
    } = alertData;
    const divClassName = `alert-section ${className || ''}`;
    return (
      <AlertPortal>
        <div
          className={divClassName}
        >
          <div className="alert-shadow" />
          <div className="alert-inner">
            { Icon && (
              <div className="alert-svg-wrapper">
                <div className="svg-container">
                  <Icon />
                </div>
              </div>
            )}
            <div className="alert-texts">
              {
                alertTitle && (
                  <h1 className="alert-title">
                    {alertTitle}
                  </h1>
                )
              }
              {
                alertText && (
                  <p className="alert-text">
                    {alertText}
                  </p>
                )
              }
            </div>
            <AlertOptions
              onClick={resolveAlert}
              option={option}
              falseText={falseText}
              trueText={trueText}
              falseButtonCols={falseButtonCols}
              trueButtonCols={trueButtonCols}
              showFalse={showFalse}
              showTrue={showTrue}
            />
          </div>
        </div>
      </AlertPortal>
    );
  }
}

Alert.propTypes = {
  resolveAlert: PropTypes.func,
  alertData: alertDataShape,
};

export {
  Alert,
};



